import {ReactNode, createContext, useEffect, useState} from 'react';
import {fetchConfig} from './api/config';
import {Environment} from '../shared/types';

export const configPromise = fetchConfig();

export type Config = {
  environment: Environment;
};
const defaultValue: Config = {
  environment: 'dev' as Environment,
};

export const EnvConfigContext = createContext(defaultValue);

export const EnvConfigContextProvider = ({children}: {children: ReactNode}) => {
  const [envConfig, setEnvConfig] = useState(defaultValue);

  useEffect(() => {
    configPromise.then((config) => {
      setEnvConfig({
        environment: config.environment as Environment,
      });
    });
  }, []);

  return (
    <EnvConfigContext.Provider value={envConfig}>
      {children}
    </EnvConfigContext.Provider>
  );
};
